import React, { useEffect, useState, useMemo } from "react";
import "./summaryStationWise.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LoadingOverlay from "react-loading-overlay";
import { SERVER_URL, USE_OVERLAY } from "../config/config";

const SummaryStationWise = ({ sessionObject }) => {
  const [overlay, setOverlay] = useState(false);
  const [data, setData] = useState([]);
  const [dateState, setDateState] = useState({
    date_from: new Date(),
    date_to: new Date(),
  });

  const clientName = process.env.REACT_APP_CLIENT;

  let columnConfig = [];

  if (clientName === "guru") {
    columnConfig = [
      { key: "station_to_name", label: "Station To" },
      { key: "pkgs", label: "Packages" },
      { key: "bilty_no_count", label: "No of Bilty" },
      { key: "freight", label: "Freight" },
      { key: "bilty_charge", label: "Bilty Charge" },
      { key: "hamali", label: "Hamali" },
      { key: "dd_charge", label: "DD Charge" },
      { key: "lc_charge", label: "LC Charge" },
      { key: "other_amount", label: "Other Amount" },
      { key: "pf", label: "PF" },
      { key: "total_amount", label: "Total Amount" },
    ];
  } else {
    columnConfig = [
      { key: "station_to_name", label: "Station To" },
      { key: "pkgs", label: "Packages" },
      { key: "bilty_no_count", label: "No of Bilty" },
      { key: "freight", label: "Freight" },
      { key: "bilty_charge", label: "Bilty Charge" },
      { key: "hamali", label: "Hamali" },
      { key: "dd_charge", label: "DD Charge" },
      { key: "total_amount", label: "Total Amount" },
    ];
  }

  const fetchData = () => {
    setOverlay(true);
    const payload = {
      date_dict: {
        date_from: dateState.date_from,
        date_to: dateState.date_to,
      },
    };

    const apiEndpoint = SERVER_URL + "/report";

    fetch(apiEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.data || []);
        setOverlay(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setOverlay(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [dateState]);

  const mergeDuplicates = useMemo(() => {
    return (data) => {
      const mergedData = {};

      data.forEach((item) => {
        const stationFrom = (item.station_from_name || "").trim().toUpperCase();
        const stationTo = (item.station_to_name || "").trim().toUpperCase();
        if (!stationFrom || !stationTo) return;

        const key = `${stationFrom}_${stationTo}`;

        if (!mergedData[key]) {
          mergedData[key] = { ...item, bilty_no_count: 1 };
          mergedData[key].pkgs = Number(item.pkgs || 0);
          mergedData[key].bilty_charge = Number(item.bilty_charge || 0);
          mergedData[key].hamali = Number(item.hamali || 0);
          mergedData[key].freight = Number(item.freight || 0);
          mergedData[key].dd_charge = Number(item.dd_charge || 0);
          mergedData[key].lc_charge = Number(item.lc_charge || 0);
          mergedData[key].pf = Number(item.pf || 0);
          mergedData[key].other_amount = Number(item.other_amount || 0);
          mergedData[key].total_amount = Number(item.total_amount || 0);
        } else {
          mergedData[key].pkgs += Number(item.pkgs || 0);
          mergedData[key].bilty_charge += Number(item.bilty_charge || 0);
          mergedData[key].hamali += Number(item.hamali || 0);
          mergedData[key].freight += Number(item.freight || 0);
          mergedData[key].dd_charge += Number(item.dd_charge || 0);
          mergedData[key].bilty_no_count++;
          mergedData[key].total_amount += Number(item.total_amount || 0);
          mergedData[key].lc_charge += Number(item.lc_charge || 0);
          mergedData[key].pf += Number(item.pf || 0);
          mergedData[key].other_amount += Number(item.other_amount || 0);
        }
      });

      return Object.values(mergedData);
    };
  }, []);

  const getUniqueStationNames = useMemo(() => {
    return () => {
      const stationNames = new Set();
      data.forEach((item) => {
        stationNames.add(item.station_from_name.toUpperCase());
      });
      return Array.from(stationNames);
    };
  }, [data]);

  const calculateTotal = useMemo(() => {
    return (data) => {
      const total = {
        pkgs: 0,
        bilty_charge: 0,
        hamali: 0,
        freight: 0,
        dd_charge: 0,
        bilty_no_count: 0,
        total_amount: 0,
        lc_charge: 0,
        pf: 0,
        other_amount: 0,
      };

      data.forEach((item) => {
        total.pkgs += Number(item.pkgs);
        total.bilty_charge += Number(item.bilty_charge);
        total.hamali += Number(item.hamali);
        total.freight += Number(item.freight);
        total.dd_charge += Number(item.dd_charge);
        total.bilty_no_count += Number(item.bilty_no_count);
        total.total_amount += Number(item.total_amount);
        total.lc_charge += Number(item.lc_charge || 0);
        total.pf += Number(item.pf || 0);
        total.other_amount += Number(item.other_amount || 0);
      });

      Object.keys(total).forEach((key) => {
        total[key] = parseFloat(total[key].toFixed(2));
      });

      return total;
    };
  }, []);

  const mergedData = mergeDuplicates(data);

  return (
    <div className="summaryContainer">
      {USE_OVERLAY && (
        <LoadingOverlay
          active={overlay}
          spinner
          text="Loading your content..."
          styles={{ wrapper: { overflow: true ? "hidden" : "scroll" } }}
        />
      )}
      <div className="dateHolder">
        <div>
          From Date:{" "}
          <DatePicker
            dateFormat="dd-MM-yyyy"
            selected={dateState.date_from}
            onChange={(date) => setDateState({ ...dateState, date_from: date })}
          />
        </div>
        <div>
          To Date:{" "}
          <DatePicker
            dateFormat="dd-MM-yyyy"
            selected={dateState.date_to}
            onChange={(date) => setDateState({ ...dateState, date_to: date })}
          />
        </div>
      </div>
      <div className="titleHolder">
        <span>Destination Wise Booking Summary Report</span>
      </div>
      <div className="summaryTable">
        {getUniqueStationNames().map((stationName) => {
          const filtered = mergedData.filter(
            (item) => item.station_from_name.toUpperCase() === stationName
          );
          const total = calculateTotal(filtered);

          return (
            <div key={stationName}>
              <div className="branchTitleHolder">
                <span className="branchTitle">Branch: {stationName}</span>
              </div>
              <table id="tabled">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    {columnConfig.map((col) => (
                      <th key={col.key}>{col.label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {columnConfig.map((col) => (
                        <td key={col.key}>
                          {col.key === "station_to_name"
                            ? item.station_to_name
                            : item[col.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
                  <tr>
                    <td>Total</td>
                    {columnConfig.map((col) => (
                      <td key={col.key}>
                        {col.key === "total_amount"
                          ? total[col.key]
                          : total[col.key]}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SummaryStationWise;
